import { IAppState } from '../common/state';
import { getRegionId } from '../utils/geo';

export const getCurrentRegionId = (state: IAppState): number => {
  return getRegionId(state.currentLocation);
};
